import Input from 'src/components/Input/Input';
import { Controller } from 'react-hook-form';
import React, { useEffect } from 'react';

export const ProjectNameField = ({ field, data = '', control, readonly, setValue, compact }) => {
  useEffect(() => {
    if (readonly && data) {
      setValue('pf_company_name', data);
      return;
    }

    if (readonly) {
      setValue('pf_company_name', '');
    }
  }, [readonly, field, data]);

  return field ? (
    <Controller
      control={control}
      name={field.key}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div className={'flex flex-col w-full'}>
          <Input
            className={'!py-2.5'}
            readonly={readonly}
            label={'Company name*'}
            type={'text'}
            placeholder={'ABC Company'}
            invalidMessage={error?.message}
            value={value || ''}
            isValid={!error?.message}
            onChange={onChange}
          />
        </div>
      )}
    />
  ) : null;
};
